import { LicenseRequest, LicenseTypeQuestion, User } from "./models";

const fakeId = 999999;

const calculateAnswer = (
  licReq: LicenseRequest,
  question: LicenseTypeQuestion
) => {
  let replaceable = [...licReq.licenseType.licenseTypeQuestions];
  // Most of these attributes are to satisfy typeorm. They're not strictly necessary.
  replaceable.push({
    id: fakeId,
    question: "totalImPercentControl",
    autoPopulated: false,
    triggersReview: false,
    triggersReviewAnswer: "",
    requiredDependencies: "",
    answerType: "",
    required: "",
    hiddenUnless: "",
    questionName: "totalImPercentControl", // This one matters
    licenseType: licReq.licenseType,
    licenseTypeId: licReq.licenseTypeId!,
    answerOptions: "",
    internal: false,
    calculation: "",
    ordering: fakeId,
    licenseTypeAnswers: [
      {
        id: fakeId,
        answer: (
          parseFloat(licReq.work.totalImPercentControl) / 100
        ).toString(), // This one matters
        createdById: fakeId,
        licenseRequest: licReq,
        licenseRequestId: licReq.id,
        licenseTypeQuestion: question,
        licenseTypeQuestionId: question.id,
        createdBy: new User(),
        answerAttachments: [],
      },
    ],
  });
  let { calculation } = question;
  let hasPercentOwned = true;
  for (const r in replaceable) {
    let answer = "0";
    if (replaceable[r].answerType === "Sum") {
      let sum = 0;
      const operands = replaceable[r].calculation.split("+");
      for (const o in operands) {
        const operandQuestion = licReq.licenseType.licenseTypeQuestions.find(
          (f) => f.questionName === operands[o]
        );
        if (operandQuestion) {
          sum += parseInt(
            operandQuestion.licenseTypeAnswers[0].answer
              ? operandQuestion.licenseTypeAnswers[0].answer
              : "0"
          );
        }
      }
      answer = sum.toString();
    } else {
      answer =
        replaceable[r].licenseTypeAnswers &&
        replaceable[r].licenseTypeAnswers.length > 0 &&
        replaceable[r].licenseTypeAnswers[0].answer !== ""
          ? replaceable[r].licenseTypeAnswers[0].answer
          : "0";
      if (
        replaceable[r].questionName === "totalImPercentControl" &&
        isNaN(parseFloat(answer))
      ) {
        hasPercentOwned = false;
      }
    }
    // this was to solve https://www.pivotaltracker.com/story/show/174480043
    // The Lyric Reprint Fee needs to be used only if they answer 'Yes' to that question
    // So the calculation is ('lyricReprint'==='Yes' ? 0.15 : 0)*totalImPercentControl
    // for 2 license types' Lyric Fee
    // All other replacements should be numbers
    answer =
      replaceable[r].questionName === "lyricReprint"
        ? answer
        : parseFloat(answer).toString();
    calculation = calculation.replace(
      new RegExp(replaceable[r].questionName, "g"),
      answer
    );
  }
  if (isNaN(parseFloat(eval(calculation)))) {
    let message = `Could not calculate ${
      question.calculation
    }. Tried ${calculation} and got ${eval(calculation)}`;
    if (!hasPercentOwned) {
      message = `This work's "Percent Owned" does not have a number`;
    }

    throw message;
  } else {
    return eval(calculation);
  }
};

export { calculateAnswer };
